<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">Documentos</h2>
  <div class="flex justify-between items-center mb-4">
    <button
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="goToCreateDocument()"
    >
      Registrar
    </button>
  </div>
  <div class="flex justify-between items-center mb-4">
    <div>
      <label class="block font-medium mb-1 text-gray-500">Estado</label>
      <select
        [(ngModel)]="selectedStatus"
        (change)="cargarDocumentos()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todos</option>
        <option value="1">Activo</option>
        <option value="0">Inactivo</option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Ordenar por</label>
      <select
        [(ngModel)]="selectedDateOrder"
        (change)="cargarDocumentos()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Fecha de creación</option>
        <option value="ASC">Más Antiguos primero</option>
        <option value="DESC">Más Recientes primero</option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Oficina</label>
      <select
        [(ngModel)]="selectedOficina"
        (change)="cargarDocumentos()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todas</option>
        <option *ngFor="let oficina of oficinas" [value]="oficina.id_oficina">
          {{ oficina.nombre | titlecase }}
        </option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Tipo</label>
      <select
        [(ngModel)]="selectedTipoDocumento"
        (change)="cargarDocumentos()"
        class="border border-gray-300 rounded py-2 px-4 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value="">Todos</option>
        <option *ngFor="let tipo of tiposDocumento" [value]="tipo">
          {{ tipo }}
        </option>
      </select>
    </div>
    <div>
      <label class="block font-medium mb-1 text-gray-500">Buscar</label>
      <div class="relative">
        <input
          type="text"
          class="border border-gray-300 rounded py-2 px-4 pl-10 pr-4 w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Nombre o ID..."
          [(ngModel)]="searchText"
          (input)="applyFilter()"
        />
        <i class="fas fa-search absolute top-3 left-3 text-gray-500"></i>
      </div>
    </div>
  </div>

  <div class="overflow-x-auto">
    <table class="min-w-full border-collapse border border-gray-200">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="py-2 px-4 border-b border-gray-200">ID</th>
          <th class="py-2 px-4 border-b border-gray-200">Nombre</th>
          <th class="py-2 px-4 border-b border-gray-200">Fecha Creación</th>
          <th class="py-2 px-4 border-b border-gray-200">Tipo Documento</th>
          <th class="py-2 px-4 border-b border-gray-200">Oficina</th>
          <th class="py-2 px-4 border-b border-gray-200">Estado</th>
          <th class="py-2 px-4 border-b border-gray-200">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let doc of getPaginatedDocuments()"
          class="hover:bg-gray-50 transition"
        >
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.id_documento }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">{{ doc.nombre }}</td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.fecha_creacion | date : "dd/MM/yyyy" }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.tipo_documento }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            {{ doc.oficina.nombre }}
          </td>
          <td class="py-2 px-4 border-b border-gray-200">
            <span
              [ngClass]="{
                'bg-green-500': doc.estado == 1,
                'bg-red-500': doc.estado == 0
              }"
              class="text-white px-3 py-1 rounded-full"
            >
              {{ doc.estado == 1 ? "Activo" : "Inactivo" }}
            </span>
          </td>
          <td
            class="py-2 px-4 border-b border-gray-200 text-center whitespace-nowrap"
          >
            <button
              class="bg-green-500 hover:bg-green-600 text-white font-semibold py-1 px-3 rounded"
              title="Ver Documentos Cargados"
              (click)="goToLoadedDocuments(doc)"
            >
              <i class="fas fa-list"></i>
            </button>
            <button
              class="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-1 px-3 ml-2 rounded"
              title="Editar"
              (click)="goToDocumentDetail(doc)"
            >
              <i class="fas fa-edit"></i>
            </button>

            <button
              [ngClass]="{
                'bg-red-500 hover:bg-red-600': doc.estado === 1,
                'bg-red-300 cursor-not-allowed': doc.estado === 0
              }"
              class="text-white font-semibold py-1 px-3 rounded ml-2"
              title="Eliminar"
              [disabled]="doc.estado === 0"
              (click)="eliminarDocumento(doc.id_documento)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="flex justify-between items-center mt-6">
    <button
      class=" hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
      [disabled]="currentPage === 1"
      (click)="changePage(currentPage - 1)"
    >
      Anterior
    </button>
    <span class="text-gray-700">Página {{ currentPage }} de {{ totalPages }}</span>
    <button
      class="hover:bg-gray-300 border text-gray-800 py-2 px-4 rounded"
      [disabled]="currentPage === totalPages"
      (click)="changePage(currentPage + 1)"
    >
      Siguiente
    </button>
  </div>
</div>
